import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import cartIcon from '../../../../commons/src/assets/icons/cart.svg'
import checkedIcon from '../../../../commons/src/assets/icons/checked.svg'
import closeIcon from '../../../../commons/src/assets/icons/close.svg'
import helpIcon from '../../../../commons/src/assets/icons/help-circle.svg'
import packageIcon from '../../../../commons/src/assets/icons/package.svg'
import pauseIcon from '../../../../commons/src/assets/icons/pause-circle.svg'
import playIcon from '../../../../commons/src/assets/icons/play-circle.svg'

import Badge from '../../../../commons/src/components/badge/Badge'
import Icon from '../../../../commons/src/components/icon'

import {OrderStatusType} from '../../order-types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    type: OrderStatusType
    size?: 'default' | 's' | 'xs'
  }
>

export type BadgeContent = {
  type: React.ComponentProps<typeof Badge>['type']
  label: string
  iconSource: string
}

export const orderStatusTypeToContentMap: Record<OrderStatusType, BadgeContent> = {
  [OrderStatusType.ORDERED]: {
    type: 'warning',
    label: 'Placed',
    iconSource: cartIcon,
  },
  [OrderStatusType.IN_PRODUCTION]: {
    type: 'cyan',
    label: 'In Production',
    iconSource: playIcon,
  },
  [OrderStatusType.SHIPPED]: {
    type: 'purple',
    label: 'Shipped',
    iconSource: packageIcon,
  },
  [OrderStatusType.RECEIVED]: {
    type: 'success',
    label: 'Received',
    iconSource: checkedIcon,
  },
  [OrderStatusType.CANCELLED]: {
    type: 'error',
    label: 'Cancelled',
    iconSource: closeIcon,
  },
  [OrderStatusType.BLOCKED]: {
    type: 'base',
    label: 'On Hold',
    iconSource: pauseIcon,
  },
  [OrderStatusType.UNKNOWN]: {
    type: 'base',
    label: 'Unknown',
    iconSource: helpIcon,
  },
}

const OrderStatusBadge = ({className, type, size = 'default', ...props}: Props) => {
  let badgeContent = orderStatusTypeToContentMap[type]
  if (!badgeContent) {
    badgeContent = orderStatusTypeToContentMap[OrderStatusType.UNKNOWN]
  }
  return (
    <div {...props} className={cn('OrderStatusBadge', {}, className)}>
      <Badge
        size={size}
        label={badgeContent.label}
        type={badgeContent.type}
        icon={<Icon source={badgeContent.iconSource} />}
      />
    </div>
  )
}

export default OrderStatusBadge
